import styled from 'styled-components';

const View = styled.div`
  margin: 20px 0;
  padding-bottom: 70px;
  position: relative;
  width: 100%;

  @media (min-width: 800px) {
    max-width: 1500px;
    padding: 0 100px;
  }
  @media only screen and (max-width: 1500px) and (min-width: 800px) {
    zoom: 80%;
  }
`;

const TicketsStyled = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  width: 100%;
  padding: 20px 20px;
  color: ${(props) => props.theme.colors.neutral900};
  font-size: 15px;
  background: ${({ theme }) => theme.colors.neutral0};
  margin-bottom: 20px;
  padding: 10px 20px;
  border-radius: 15px;
  border: 1px solid ${(props) => props.theme.colors.neutral900};
  span {
    color: ${(props) => props.theme.colors.neutral900};
  }
`;

const TicketsMobileStyled = styled.div`
  cursor: pointer;
  padding: 20px 0;
  color: ${(props) => props.theme.colors.neutral900};
  font-size: 14px;
  line-height: 20px;

  background: ${({ theme }) => theme.colors.neutral50};
  margin-bottom: 20px;
  padding: 10px 20px;
  box-shadow: ${({ theme }) => theme.shadows.shadowXS};
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const TicketsHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 20px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  font-size: 17px;
  color: ${(props) => props.theme.colors.neutral900};
  font-weight: 600;
`;

const TicketComment = styled.div<{ isUser: boolean }>`
  background: ${({ theme, isUser }) =>
    isUser ? theme.colors.neutral100 : theme.colors.primary900};
  color: ${({ theme, isUser }) =>
    isUser ? theme.colors.neutral900 : theme.colors.neutral0};
  /* box-shadow: ${({ theme }) => theme.shadows.shadowXS}; */

  border-radius: 12px;
  padding: 10px 20px;
  width: auto;
  display: inline-flex;
  // margin: 0 80px 0 0;
  margin-bottom: 5px;
  overflow-wrap: break-word;
  @media (max-width: 800px) {
  }
`;

export {
  TicketsStyled,
  TicketsHeader,
  TicketsMobileStyled,
  View,
  TicketComment
};
